export const tr = {
    'column-title-conversion': 'Dönüşüm',
    'column-title-cpa': 'CPA, {currency}',
    'column-title-percent-conversion': 'Dönüşümler, %',
    'goals-statistics': 'Hedeflere göre istatistikler'
};
